module.exports = __webpack_public_path__ + "69f7b824e3def62789d5f1256a1d191f.png";